import { $t } from "../../../utils/intl";
import { handleTextField } from "../../prefill/helpers";
import { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { TextFieldControl } from "./TextFieldControl/TextFieldControl";
import { defaultToReviewString } from "../review/reviewString.helpers";

export type TextFieldValue = string;

export const textFieldConfig: FieldRegistryConfig<TextFieldValue> = {
  icon: "text",
  control: (props) => <TextFieldControl placeholder={$t(fieldsText.textPlaceholder)} {...props} />,
  prefill: handleTextField,
  toReviewString: defaultToReviewString,
};
